import styled from "styled-components";

const ErrorModalStyle = styled.div`
  .modal {
    background-color: #00000077;
    position: fixed;
    top: 0%;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .card {
    background-color: #ffffff;
    text-align: center;
    padding: 10px;
    .img {
      width: 100px;
    }
    .title {
      margin: 20px 0;
      font-size: 17px;
    }
    .centerCard {
      display: flex;
      justify-content: center;
      padding: 0 50px;
    }
    .btnN {
      padding: 10px 30px;
      border-radius: 5px;
      border: 3px solid red;
      color: red;
      transition: 0.2s;
      font-weight: 600;
      font-size: 17px;
    }
    .btnN:hover {
      background-color: red;
      color: white;
    }
  }
`;
export default ErrorModalStyle;
